import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import api from '../../../app/api';

const ActivationModal = (props) => {
  const show = props.show;
  const setShow = props.setShow;
  const title = props.title;
  const message = props.message;
  const success = props.success;
  const handleClose = () => setShow(false);

  const [email, setEmail] = useState('');

  const handleResendActivationLink = async () => {
      props.setLoading(true);
      await api.post(
        '/auth/activate/resend?email=' + email,
        {
          withCredentials: true
        }
      ).then((r) => {
        props.setErrorTitle("Activation Link Sent");
        props.setErrorMessage("A new activation link has been sent to your email.");
        props.setErrorShow(true);
        props.setLoading(false); 
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          props.setErrorTitle("Your account is activated");
          props.setErrorMessage("Your account is already activated. You can proceed to log in.");          
        } else if (error.response && error.response.status === 404) {
          props.setErrorTitle("Email Not Found");
          props.setErrorMessage("No account found with that email. Please check your email and try again.");
        } else {
          props.setErrorTitle("Failed to Resend Activation Link");
          props.setErrorMessage("An error occurred while resending the activation link. Please try again.");
        }
        props.setErrorShow(true);
        props.setLoading(false);
      });
    }

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message}
        {!success?
          <Form>
            <Form.Label style={{fontSize: '0.6em'}} className="my-0 py-0"
              htmlFor='email'>Email</Form.Label>
            <Form.Control
              key='email'
              className="mt-0"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <br />
            <Button variant="primary" onClick={handleResendActivationLink}>
              Request New Activation Link
            </Button>
          </Form>:<></>}
        </Modal.Body>
        <Modal.Footer>          
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ActivationModal;